import {
  Component,
  Input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  BdMapsStateSelectInlineSingleComponent,
  BdMapsStateSelectOptions,
} from '@bindoc-projects/maps-lib/ui/state-select';
import { BdState } from '@bindoc-projects/geographic-domain-lib';
import { AysDrgBaseRate } from '@bindoc-projects/code-domain-lib';

@Component({
  selector: 'kost-data-import-de-new-data-parameters-base-rates',
  template: `
    <bd-maps-state-select-inline-single
      [options]="stateSelectOptions"
      (stateSelect)="onStateChange($event)"
    >
    </bd-maps-state-select-inline-single>
  `,
  styles: [``],

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [BdMapsStateSelectInlineSingleComponent],
})
export class KostDataImportDeNewDataParametersBaseRatesComponent {
  @Input()
  public state: BdState;

  @Input()
  public baseRateOptions: { [year: string]: AysDrgBaseRate[] };

  public readonly update = output<{
    baseRates: {
      [year: string]: number;
    };
    state: BdState;
  }>();

  public readonly stateSelectOptions: BdMapsStateSelectOptions = {
    includeBund: true,
    resetOption: false,
  };

  public baseRates: { [year: string]: number };

  public onStateChange(state: BdState | null) {
    this.state = state;

    if (!state) {
      this.baseRates = null;
    } else {
      const baseRatesOfState: { [year: string]: number } = {};

      Object.keys(this.baseRateOptions).forEach((year) => {
        const stateItem = this.baseRateOptions[year].find(
          (value) => value.state.id === state.id,
        );

        if (stateItem) {
          baseRatesOfState[year] = stateItem.value;
        }
      });

      this.baseRates = baseRatesOfState;
    }

    this._emit();
  }

  private _emit(): void {
    this.update.emit({
      state: this.state,
      baseRates: this.baseRates,
    });
  }
}
